  (function () {
    function initAceAppRef(root) {
      var sections = root.querySelectorAll('[data-ace-app-ref]');

      sections.forEach(function (section) {
        if (section.dataset.aceAppRefInitialized === 'true') return;
        section.dataset.aceAppRefInitialized = 'true';

        var phones = Array.prototype.slice.call(section.querySelectorAll('.ace-app-ref__phone'));
        var dots = Array.prototype.slice.call(section.querySelectorAll('.ace-app-ref__dot'));
        var phonesWrap = section.querySelector('.ace-app-ref__phones');
        var current = 0;
        var timer = null;
        var resumeTimer = null;
        var speed = parseInt(section.dataset.aceAppRefSpeed, 10) || 4800;
        var dragThreshold = 45;
        var resumeDelay = 1500;
        var isDragging = false;
        var pointerId = null;
        var dragStartX = 0;
        var dragStartY = 0;
        var dragLastX = 0;
        var dragLastY = 0;

        if (!phones.length) return;

        function render() {
          var total = phones.length;
          var left = (current - 1 + total) % total;
          var right = (current + 1) % total;

          phones.forEach(function (phone, index) {
            phone.classList.remove('is-active', 'is-left', 'is-right');

            if (index === current) {
              phone.classList.add('is-active');
            } else if (index === left) {
              phone.classList.add('is-left');
            } else if (index === right) {
              phone.classList.add('is-right');
            }
          });

          dots.forEach(function (dot, index) {
            dot.classList.toggle('is-active', index === current);
          });
        }

        function next() {
          current = (current + 1) % phones.length;
          render();
        }

        function previous() {
          current = (current - 1 + phones.length) % phones.length;
          render();
        }

        function clearResumeTimer() {
          if (resumeTimer) {
            clearTimeout(resumeTimer);
            resumeTimer = null;
          }
        }

        function stop() {
          if (timer) {
            clearInterval(timer);
            timer = null;
          }
        }

        function start() {
          clearResumeTimer();
          stop();
          if (phones.length > 1 && speed > 0 && !document.hidden) {
            timer = setInterval(next, speed);
          }
        }

        function resumeSoon() {
          clearResumeTimer();
          stop();
          if (phones.length > 1 && speed > 0 && !document.hidden) {
            resumeTimer = setTimeout(start, resumeDelay);
          }
        }

        dots.forEach(function (dot, index) {
          dot.addEventListener('click', function () {
            current = index;
            render();
            resumeSoon();
          });
        });

        if (phonesWrap && phones.length > 1) {
          phonesWrap.addEventListener('dragstart', function (event) {
            event.preventDefault();
          });

          phonesWrap.addEventListener('pointerdown', function (event) {
            if (event.pointerType === 'mouse' && event.button !== 0) return;

            isDragging = true;
            pointerId = event.pointerId;
            dragStartX = event.clientX;
            dragStartY = event.clientY;
            dragLastX = event.clientX;
            dragLastY = event.clientY;
            phonesWrap.classList.add('is-dragging');
            clearResumeTimer();
            stop();

            if (phonesWrap.setPointerCapture) {
              try {
                phonesWrap.setPointerCapture(pointerId);
              } catch (error) {
                // Some embedded browsers can reject capture after quick taps.
              }
            }
          });

          phonesWrap.addEventListener(
            'pointermove',
            function (event) {
              if (!isDragging || event.pointerId !== pointerId) return;

              dragLastX = event.clientX;
              dragLastY = event.clientY;

              var distanceX = dragLastX - dragStartX;
              var distanceY = dragLastY - dragStartY;

              if (Math.abs(distanceX) > 8 && Math.abs(distanceX) > Math.abs(distanceY)) {
                event.preventDefault();
              }
            },
            { passive: false }
          );

          function endDrag(event) {
            if (!isDragging || event.pointerId !== pointerId) return;

            var distanceX = (event.clientX || dragLastX) - dragStartX;
            var distanceY = (event.clientY || dragLastY) - dragStartY;

            isDragging = false;
            phonesWrap.classList.remove('is-dragging');

            if (phonesWrap.releasePointerCapture) {
              try {
                phonesWrap.releasePointerCapture(pointerId);
              } catch (error) {
                // Capture may already be released when leaving the iframe.
              }
            }

            pointerId = null;

            if (Math.abs(distanceX) >= dragThreshold && Math.abs(distanceX) > Math.abs(distanceY)) {
              if (distanceX < 0) {
                next();
              } else {
                previous();
              }
            }

            resumeSoon();
          }

          phonesWrap.addEventListener('pointerup', endDrag);
          phonesWrap.addEventListener('pointercancel', function (event) {
            if (!isDragging || event.pointerId !== pointerId) return;
            isDragging = false;
            pointerId = null;
            phonesWrap.classList.remove('is-dragging');
            resumeSoon();
          });
        }

        section.addEventListener('mouseenter', function () {
          clearResumeTimer();
          stop();
        });
        section.addEventListener('mouseleave', function () {
          if (!isDragging) resumeSoon();
        });
        document.addEventListener('visibilitychange', function () {
          if (document.hidden) {
            clearResumeTimer();
            stop();
          } else {
            start();
          }
        });

        render();
        start();
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        initAceAppRef(document);
      });
    } else {
      initAceAppRef(document);
    }

    document.addEventListener('shopify:section:load', function (event) {
      initAceAppRef(event.target);
    });
  })();
